import {
  // updateSubscription,
  createSubscription,
  cancelSubscription,
  pauseSubscription,
  resumeSubscription,
  reactivateSubscription,
  updatePlan,
  // getSubscriptionStatus,
  fetchSubscriptionDetails,
  fetchBillingDetails,
  fetchPlans,
  updateBillingInfo,
  cancelPendingChange,
  fetchRedeemedCoupons,
  redeemCoupon,
  deleteBillingInfo,
  validateReferral,
  fetchAccountBalance,
} from '../api/subscription';
import { store } from '../../app/store';
import {
  setSubscription,
  resetSubscription,
  setSubscriptionLoaded,
} from './SubscriptionSlice';
import { setBilling, resetBilling } from './BillingSlice';
import ReactPixel from 'react-facebook-pixel';

export const handleFetchSubscriptionDetails = async () => {
  try {
    store.dispatch(setSubscriptionLoaded(false));
    let subscriptionDetails = await fetchSubscriptionDetails()
      .then((res) => {
        const details = res && res.data ? res.data : {};
        return details;
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          if (err.response.data.msg === 'No subscription found for user') {
            return 'NO_SUB_ACCOUNT';
          }
        }
        return null;
      });
    if (
      subscriptionDetails !== null &&
      subscriptionDetails !== 'NO_SUB_ACCOUNT'
    ) {
      store.dispatch(setSubscription(subscriptionDetails));
    } else {
      store.dispatch(resetSubscription());
      throw new Error('No Subscription Found For User');
    }
  } catch (err) {
    console.error(err.message);
  } finally {
    store.dispatch(setSubscriptionLoaded(true));
  }
};

export const handleFetchBillingDetails = async () => {
  try {
    let billingDetails = await fetchBillingDetails()
      .then((res) => {
        const details = res && res.data ? res.data : {};
        return details;
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          if (err.response.data.msg === 'No subscription found for user') {
            return 'NO_SUB_ACCOUNT';
          }
        }
        return null;
      });
    if (billingDetails !== null && billingDetails !== 'NO_SUB_ACCOUNT') {
      store.dispatch(setBilling(billingDetails));
    } else {
      store.dispatch(resetBilling());
      throw new Error('No Subscription Found For User');
    }
  } catch (err) {
    console.error(err.message);
  }
};

/**
 * Fetches the plans for the current user
 * @returns a list of plans available to the current user
 */
export const handleFetchPlans = async () => {
  let plans = await fetchPlans().then((res) => {
    const details = res && res.data ? res.data : {};
    return details;
  });
  return plans;
};

/**
 * Fetches the plans for the current user
 * @returns a list of plans available to the current user
 */
export const handleFetchRedeemedCoupons = async () => {
  let coupons = await fetchRedeemedCoupons().then((res) => {
    const details = res && res.data ? res.data : {};
    return details;
  });
  return coupons;
};

/**
 * Handler which creates a new subscription for a user
 * @param {String} planCode
 * @param {String} billingToken
 */
export const handleCreateSubscription = async (
  planCode,
  billingToken,
  couponCode,
  referrerId
) => {
  const subInfo = {
    plan_code: planCode,
    currency: 'USD',
  };
  if (billingToken !== undefined) {
    if (billingToken.length > 0) {
      subInfo.billing_token = billingToken;
    }
  }
  if (couponCode !== undefined) {
    if (couponCode.length > 0) {
      subInfo.coupon_code = couponCode;
    }
  }
  if (referrerId !== undefined) {
    if (referrerId.length > 0) {
      subInfo.referrer = referrerId;
    }
  }
  const subscriptionDetails = await createSubscription(subInfo).then(
    (res) => res.data
  );
  subscriptionDetails && store.dispatch(setSubscription(subscriptionDetails));
  handleFetchBillingDetails();
  ReactPixel.trackCustom('LINKtivitySubscribe');
};

/**
 * Handles canceling the user's current subscription
 */
export const handleCancelSubscription = async () => {
  await cancelSubscription().then((res) => {
    const details = res && res.data ? res.data : null;
    details && store.dispatch(setSubscription(details));
  });
};

/**
 * Handler which pauses a subscription
 * @param {string} cycles
 */
export const handlePauseSubscription = async (cycles) => {
  await pauseSubscription(cycles).then((res) => {
    const details = res && res.data ? res.data : null;
    details && store.dispatch(setSubscription(details));
  });
};

/**
 * Handler which redeems a coupon to a subscription
 * @param {string} couponCode
 */
export const handleRedeemCoupon = async (couponCode) => {
  const params = {
    CouponCode: couponCode,
  };
  let couponRedemption = await redeemCoupon(params).then((res) => {
    const details = res && res.data ? res.data : null;
    return details;
  });
  return couponRedemption;
};

/**
 * Handles resuming the user's paused subscription
 */
export const handleResumeSubscription = async () => {
  await resumeSubscription().then((res) => {
    const details = res && res.data ? res.data : null;
    details && store.dispatch(setSubscription(details));
  });
};

/**
 * Handles reactivating the user's currently canceled subscription
 */
export const handleReactivateSubscription = async () => {
  await reactivateSubscription().then((res) => {
    const details = res && res.data ? res.data : null;
    details && store.dispatch(setSubscription(details));
  });
};

/**
 *
 * @param {string} planCode - The plan code for the new plan to update the subscription to
 */
export const handleUpdatePlan = async (planCode) => {
  await updatePlan(planCode).then(() => {
    handleFetchSubscriptionDetails();
  });
};

/**
 * Handles the update of the billing info of the user
 * @param {String} billingToken -Billing token from Recurly
 * @param {function} setErrorMessage
 * @returns
 */
export const handleUpdateBillingInfo = async (billingToken) => {
  const payload = {
    billing_token: billingToken,
  };
  await updateBillingInfo(payload).then((res) => {
    const details = res && res.data ? res.data : {};
    details && store.dispatch(setBilling(details));
  });
};

/**
 * Cancels any pending change that currently exists on the user's current subscription
 */
export const handleCancelPendingChange = async () => {
  await cancelPendingChange().then(() => {
    handleFetchSubscriptionDetails();
  });
};

/**
 * Cancels any pending change that currently exists on the user's current subscription
 */
export const handleDeleteBillingInfo = async () => {
  await deleteBillingInfo().then(() => {
    store.dispatch(resetBilling());
  });
};

export const handleValidateReferral = async (referrerId) => {
  let validReferral = await validateReferral(referrerId).then((res) => {
    const validReferralRes = res && res.data ? res.data.ReferralValid : false;
    return validReferralRes;
  });
  return validReferral;
};

/**
 * Fetches the account balance for the current user
 * @returns an object containing balance info
 */
export const handleFetchAccountBalance = async () => {
  let balance = await fetchAccountBalance().then((res) => {
    const details = res && res.data ? res.data : {};
    return details;
  });
  return balance;
};
